import styled from 'styled-components'

import { sv } from '@ucheba/utils/helpers/styles/variables'
import { Tooltip } from '@ucheba/ui/components/Tooltip/desktop'

import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'

const GridColStyled = styled(GridCol)`
  padding: 0;
  margin: 0;
`

const GridStyled = styled(Grid)`
  margin: 0;
`

const Divide = styled.div`
  border-top: 1px solid ${sv.color.gray9};
`

const TooltipStyled = styled(Tooltip)`
  display: inline;
`

export default { Divide, TooltipStyled, GridColStyled, GridStyled }
